// extracted by mini-css-extract-plugin
export default {"pagination":"SuperPagination_pagination__B4Leo","text1":"SuperPagination_text1__LslSA","text2":"SuperPagination_text2__PUTHy"};